import { useState } from 'react';
import { useTablePreferences } from '../container';

/**
 * A yes-or-no habit of this device, remembered across visits, with the default
 * the screen gives for one never chosen. Request of 5 October 2026, section 5,
 * for vibration on confirmations.
 */
export function useDeviceSetting(key: string, fallback: boolean): [boolean, (on: boolean) => void] {
  const preferences = useTablePreferences();
  const [on, setOn] = useState(() => preferences.setting(key) ?? fallback);
  return [
    on,
    (next: boolean) => {
      setOn(next);
      preferences.rememberSetting(key, next);
    },
  ];
}
